import { render } from "./BlogForm.vue?vue&type=template&id=47a1dcae"
import script from "./BlogForm.vue?vue&type=script&lang=js"
export * from "./BlogForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__